<template>
    <div class='dataResources_wrap'>
        <div class='banner_wrap'>
            <div class='banner_title'>数据接口系统</div>
            <div class='search_wrap'>
                <el-input @change='pages.currentPage = 1' @keyup.enter.native='getTableList' placeholder='关键字'
                          prefix-icon='el-icon-search' v-model='searchKey'></el-input>
                <el-button type='primary' @click='getTableList'>搜索</el-button>
            </div>
            <div class='banner_text'>
                提供各类数据,包括金融量价数据、经济数据、金融基本面数据、以及空气质量、电影票房等创新数据
            </div>
        </div>
        <!-- 过滤导航栏 -->
        <div class='filter_wrap'>
            <div class="filter_column" v-for="item in dataListFilter" :key="item.type">
                <div class="column_title">
                    <i class="iconfont icon-mokuai"> {{item.filterTitle}}</i>
                </div>
                <div class="column_brief">
                    {{item.brief}}
                </div>
                <div class="column_wrap">
                    <div @click="filterData(column.index,item.filterTitle,item.type)" :class="[{'active_column':column.index == activeFilterId && column.type == menuType},'column_item']" v-for="column in item.FilterList" :key="column.index">{{column.title}}</div>
                </div>
            </div>
        </div>
        <!-- <div class="data_type">
            <div class="current_type">{{filterTitle}}</div>
            <div v-if="filterTitle == '实时数据接口'">real-time data access interface</div>
            <div v-if="filterTitle == '公共数据'">open data</div>
            <div v-if="filterTitle == '不限数据类型'">all data types</div>
        </div> -->
        <!-- 过滤栏目 -->
        <div class="content_wrap">
            <div v-for='item in dataList' @mouseenter='activeId = item.id' @mouseleave='activeId = -1' :key='item.id'
                 @click='toCourse(item.id,item.type)' class='item'>
                <div class='img_wrap'>
                    <div class='brief' v-if='item.id == activeId'>
                        {{ item.summary }}
                    </div>
                    <img :src='item.imageUrl' v-else>
                </div>
                <div class='item_content'>
                    <div>
                        <div class='item_title'>{{ item.title }}</div>
                        <div class='item_drc' style='display:flex'>
                            <div class="drc_name">简介:</div>
                            <div class="drc_text">{{item.summary}}</div>
                        </div>
                    </div>
                    <div class="item_button">
                        <i class="iconfont icon-yanjing">&nbsp;&nbsp;{{item.browseNum}}</i>
                        <i class='iconfont icon-dianzan' :style="item.isLike == 0 ? '':'color:#002D72'"
                           @click.stop='setLike(item.id)'>&nbsp;&nbsp;{{ item.likeNum }}</i>
                    </div>
                </div>
            </div>
            <div class='compet_item_surplus' v-for='i in surplusCount' :key="'index'+i"></div>
        </div>
        <!-- 底部分页 -->
        <div class='page_wrap'>
            <el-pagination layout='prev, pager, next' :page-size='8' @current-change='getTableList'
                           :current-page.sync='pages.currentPage' :total='pages.total'></el-pagination>
        </div>
    </div>
</template>
<script>
import { giveLike, queryResource, resourceMenu } from '../../../utils/api';

export default {
    data() {
        return {
            activeId: -1,
            pages: {
                currentPage: 1,
                total: 0
            },
            filterTitle: '不限数据类型',
            activeFilterId: 0,
            menuType: 1,
            dataListFilter: [],
            searchKey: '',
            dataList: [],
            surplusCount: '',
            resourcesData1: []
        };
    },
    mounted() {
        // this.getTableList()
        this.getResourceMenu();
    },
    methods: {
        //去数据资源下载系统
        toDataResources() {
            window.open(`${this.$config.SYSTEM_URL}/source/#/main?token=${sessionStorage.getItem('token')}`, '_blank');
        },

        //获取数据资源导航栏目录
        getResourceMenu() {
            resourceMenu().then(res => {
                let obj = {
                    FilterList: res.data[0].menuList,
                        filterTitle:res.data[0].name,
                        brief:res.data[0].summary,
                        type:res.data[0].type
                    }
                    this.dataListFilter[0] = obj
                    this.filterData(res.data[0].menuList[0].index,res.data[0].name,res.data[0].type)
                    // res.data.forEach((item,index) => {
                    //     this.dataListFilter[index].FilterList = item.menuList
                    //     this.dataListFilter[index].filterTitle = item.name
                    //     this.dataListFilter[index].brief = item.summary
                    //     this.dataListFilter[index].type = item.type
                    // });
                }).catch(err => {})
            },

            //基于导航栏筛选数据
            filterData(id,name,type){
                this.pages.currentPage = 1
                this.menuType = type
                this.activeFilterId = id
                this.filterTitle = name
                this.getTableList()
            },

            //给数据资源点赞
            setLike(itemId){
                giveLike({ resourceId: itemId }).then(res => {
                    this.getTableList();
                }).catch(err=>{})
            },

            //获取数据列表
            async getTableList(){
                let params = {
                    keyword:this.searchKey,
                    page:this.pages.currentPage,
                    size:8,
                    type:1,
                    fieldIds:this.activeFilterId
                }
                await queryResource(params).then(res => {
                    this.pages.total = res.data.totalCount;
                    this.dataList = res.data.list;
                    this.surplusCount = this.$core.setSurplusCount(this.dataList.length, 4);
                }).catch(err => {
                });
            },

            //去课程详情页面
            toCourse(val,type){
                this.$store.commit('setCourseId',{courseId:val})
                if(type == 1){
                    this.$router.push({ path: '/courseDetail', query: { courseId: val } });
                } else {
                    this.$router.push({
                        path: '/communityDetail',
                        query: {
                            id: val,
                            source: 1
                        }
                    });
                }
            },

    }
}
</script>
<style scoped lang='scss'>
.data_type {
    text-align: center;
    margin: 0px 0px 30px 0px;
    line-height: 2;
    font-size: 18px;
    color: #333;

    .current_type {
        font-weight: bold;
        font-size: 24px;
    }
}
.filter_wrap{
    box-sizing: border-box;
    padding: 20px 50px;
    display: flex;
    justify-content: space-between;
    .filter_column{
        width: 100vw;
        box-sizing: border-box;
        padding: 50px 50px 30px 50px;
        background: white;
        color: #333333;
        box-shadow: 0px 3px 6px #E8E8E8;
        .column_title{
            margin-bottom: 10px;
        }
    }
    .filter_column:hover{
        box-shadow: 0px 3px 6px #9C9C9C;
    }
    i{
        font-size: 23px;
        font-weight: bold;
    }
    .column_wrap{
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        .resource_text{
            line-height: 1.8;
        }
        .enter_resource{
            text-align: center;
            margin-top: 10px;
        }
        .column_item{
            font-size: 17px;
            margin-right: 50px;
            line-height: 2;
            letter-spacing: 1px;
        }
        .column_item:hover{
            cursor: pointer;
            color: #5277F7;
        }
    }
    .active_column{
        color: #5277F7;
    }
}
/deep/.el-pagination .btn-prev{
    background: none;
}
/deep/.el-pagination .btn-next{
    background: none;
}
/deep/ .number{
    font-size: 22px;
    font-weight: 50;
    color: #909399;
    background: none;
}
.icon-dianzan:hover{
    color: #5277F7;
    opacity: 0.7;
}
.page_wrap{
    height: 60px;
    line-height: 60px;
    text-align: center;
}
.compet_item_surplus{
    width: 21%;
}
.item{
    width: 21%;
    border-radius: 5px;
    background: black;
    box-shadow: 1px 5px 11px -2px rgba(0,0,0,0.2);
    -webkit-box-shadow: 1px 5px 11px -2px rgba(0,0,0,0.2);
    -moz-box-shadow: 1px 5px 11px -2px rgba(0,0,0,0.2);
    margin-bottom: 45px;
    color: #3C3C3C;
    .img_wrap{
        height: 180px;
        width: 100%;
        opacity: 0.7;
        overflow: hidden;
        img{
            width: 100%;
            transition: opacity .3s, transform .3s ease;
        }
        // img:hover {
        //     transition: opacity .4s, transform .4s ease;
        // 	transform:scale(1.2)
        // }
        .brief{
            color: white;
            padding: 20px 30px;
            box-sizing: border-box;
            font-size: 17px;
            line-height: 1.6;
            height: 150px;
            text-align: justify;
            display: -webkit-box;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 5;//当属性值为3，表示超出3行隐藏
        }
    }
    .item_content{
        background:white;
        box-sizing: border-box;
        padding: 0px 20px;
        .item_title{
            font-family: '黑体';
            height: 45px;
            line-height: 45px;
            font-size: 20px;
        }
        .item_drc{
            .drc_name{
                min-width: 50px;
            }
            .drc_text{
                min-height: 45px;
                width: 100%;
                display: -webkit-box;
                text-overflow: ellipsis;
                overflow: hidden;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;//当属性值为3，表示超出3行隐藏
            }
        }
        .item_button{
            height: 30px;
            display: flex;
            justify-content: flex-end;
            box-sizing: border-box;
            i{
                font-size: 18px;
                margin: 0px 10px;
            }
        }
    }

}
.item:hover{
    cursor: pointer;
    box-shadow: 1px 9px 15px -5px rgba(0,0,0,0.4);
    background: #5277F7;
    .img_wrap{
        opacity: 1;
    }
}
.dataResources_wrap{
    background: #FAFAFA;
    .banner_wrap{
        width: 100%;
        height: 600px;
        background: url(../../../assets/img/data_banner_two.png) 0 0/100% 100% no-repeat;
        .banner_title{
            font-size: 50px;
            color: white;
            font-weight: 600;
            text-align: center;
            padding: 100px 0px 30px 0px;
            letter-spacing: 2px;
        }
        .banner_text{
            color:#ccc;
            font-size: 19px;
            letter-spacing: 1px;
            line-height: 1.5;
            text-align:center;
        }
        .show_button{
            margin:50px 0px 0px 80px;
            width: 250px;
            height: 65px;
            font-size: 25px;
            border-radius: 8px;
        }
    }
    .search_wrap{
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
        .el-input{
            width: 600px;

        }
    }
    .content_wrap{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        box-sizing: border-box;
        margin-top: 40px;
        padding: 0px 100px;
    }
}
</style>
